import React, { Component } from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

import ColumnFormatter from './../../common/ColumnFormatter';

export class AutoCallDashboard extends Component {
    displayName = AutoCallDashboard.name;

    constructor(props) {
        super(props);
        this.state = { data: [], loading: true, agencyName: "" }

        const requestOptions = {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${this.props.auth.getAccessToken()}`,
                'Content-Type': 'application/json'
            }
        };

        fetch(`api/AutoCallService/${localStorage.getItem('agency_key')}/`, requestOptions)
            .then(response => response.json())
            .then(data => this.setState({ data, loading: false }));
    }

    renderRecordings(data) {

        return (
            <div>
                <h2>Court Date Check</h2>
                <BootstrapTable data={data} bordered={true} striped>
                    <TableHeaderColumn dataField='clientId' width="4%" dataFormat={ColumnFormatter.editClientFormatter}
                        filter={{ type: 'TextFilter', delay: 500 }} dataSort>Client</TableHeaderColumn>
                    <TableHeaderColumn dataField='transcription' width="46%"
                        filter={{ type: 'TextFilter', delay: 500 }} > Transcription</TableHeaderColumn>
                    <TableHeaderColumn dataField='createDate' width="20%"
                        filter={{ type: 'TextFilter', delay: 500 }} dataFormat={ColumnFormatter.asDate} 
                        dataSort>Create Date </TableHeaderColumn>
                    <TableHeaderColumn dataField='recordingUrl' isKey width="30%"
                        dataFormat={ColumnFormatter.asAudio}>Recording </TableHeaderColumn>

                </BootstrapTable>
            </div>
        );
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading..</em></p>
            : this.renderRecordings(this.state.data);

        return (
            <div>
                {contents}
            </div>
            )
    }

}



// WEBPACK FOOTER //
// ./src/components/AutoCall/AutoCallDashboard.js